import {makeStyles} from "@material-ui/core/styles";

const StyleWelcomeView = makeStyles(theme => ({
    welcomeView: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: theme.rootPadding
    },
    imageWelcome: {
        display: "flex",
        marginTop: 60,
        marginBottom: 40,
        justifyContent: "center"
    },
    currentQuizWelcome: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 30
    },
    subTitle: {
        color: 'gray',
    },
    testName: {
        paddingBottom: 20,
        textTransform: 'uppercase'
    },
    testInfo: {
        paddingTop: 40,
        paddingBottom: 40
    },
    root: {
        height: 300,
        flexGrow: 1,
        minWidth: 300,
        border: 'none',
        outline: 'none'
    },
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
    },
    paper: {
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        outline: 'none',
        padding: '10px 10px',
        textAlign: 'center',
    },
}));

export default StyleWelcomeView;